try {
  (function() {
    function __ept(key, fallback, vars) {
      let val = window.EPRIS_TRANS && window.EPRIS_TRANS[key] || fallback;
      if (vars)
        for (const k in vars) val = val.split("{" + k + "}").join(vars[k]);
      return val
    }
    const META_URL = "/collections/alle-parfums?view=meta-json-v3.json",
      CACHE_KEY = "epris_meta_v7";
    /* Manuelle Korrekturen pro N°-Code — greift NUR fuer den genannten Code;
       alles andere laeuft unveraendert ueber den Meta-Feed.
       mobileOnly:true blendet den Duft auf Desktop komplett aus der Auswahl aus. */
    const EPRIS_OVERRIDES = {
      "619": {
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris-619-baccarat-rouge-540-duftzwilling-solo-2026.jpg?v=1790897078",
        title: "CRISTALLO ROSSO",
        vendor: "Inspiriert vom Bac*** Rouge ***",
        mobileOnly: true
      }
    };
    /* Gleiche Grenze wie das Theme (min-width:1000px = Desktop) */
    const isMobileView = () => !window.matchMedia("(min-width: 1000px)").matches;
    let metaCache = null,
      ALL_OPTIONS = [],
      initialized = !1,
      initRunning = !1,
      initTimer = null,
      modal = null,
      modalSlotsEl = null,
      modalHeadlineEl = null,
      search = null,
      results = null,
      filterBar = null,
      activeFilters = {
        geschlecht: null,
        dufttyp: []
      };
    const DUFTRICHTUNG_FILTERS = [{
        key: "frisch",
        label: "Frisch",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris_duftnote_frisch.jpg?v=1777559295",
        match: ["frisch", "aqua", "marin", "aquatisch", "zitr", "citrus", "bergamot", "limet"]
      }, {
        key: "zitrisch",
        label: "Zitrisch",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris_duftnote_zitrisch.jpg?v=1777559295",
        match: ["zitr", "citrus", "bergamot", "limet"]
      }, {
        key: "blumig",
        label: "Blumig",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris_duftnote_blumig.jpg?v=1777559295",
        match: ["blumig", "floral", "rose", "jasmin", "veil"]
      }, {
        key: "suess",
        label: "S\xFC\xDF",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris_duftnote_suess.jpg?v=1777559295",
        match: ["s\xFC\xDF", "suess", "honig", "gourmand", "karam", "vanil"]
      }, {
        key: "vanille",
        label: "Vanille",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris_duftnote_vanille.jpg?v=1777559295",
        match: ["vanil"]
      }, {
        key: "holzig",
        label: "Holzig",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris_duftnote_holzig.jpg?v=1777559296",
        match: ["holz", "wood", "sandel", "zedern", "cedar"]
      }, {
        key: "orientalisch",
        label: "Orientalisch",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/epris_duftnote_orientalisch.jpg?v=1777559296",
        match: ["orient", "oud", "amber", "spicy", "w\xFCrz", "myrr"]
      }],
      GESCHLECHT_FILTERS = [{
        key: "damen",
        label: "Damen",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/damen_duefte.jpg?v=1777556523"
      }, {
        key: "herren",
        label: "Herren",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/herren_duefte.jpg?v=1777556523"
      }, {
        key: "unisex",
        label: "Unisex",
        image: "https://cdn.shopify.com/s/files/1/0782/7400/3287/files/unisex_duefte.jpg?v=1777556523"
      }];
    let activeSlotIndex = 0,
      slots = [],
      slotsState = [],
      appSelects = [],
      bundleSize = 0;
    async function loadMeta() {
      try {
        const cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) {
          const parsed = JSON.parse(cached);
          if (Array.isArray(parsed) && parsed.length && parsed[0].image !== void 0) return metaCache = parsed, metaCache
        }
      } catch {}
      try {
        const json = await (await fetch(META_URL, {
          cache: "force-cache"
        })).json();
        if (!Array.isArray(json)) return metaCache = [], metaCache;
        metaCache = json;
        try {
          sessionStorage.setItem(CACHE_KEY, JSON.stringify(metaCache))
        } catch {}
        return metaCache
      } catch {
        return metaCache = [], metaCache
      }
    }
    const normalize = s => (s || "").toLowerCase().trim(),
      extractCode = txt => {
        const m = (txt || "").match(/n°\s*([0-9]{2,4})/i);
        return m ? m[1] : ""
      },
      getSelects = () => {
        const sb = document.querySelector("#simple-bundles-io-options");
        return sb ? [...sb.querySelectorAll("select")] : []
      },
      markBundleUiReady = () => {
        document.body.classList.add("epris-bundle-ui-ready")
      },
      markBundleUiFailed = () => {
        document.body.classList.remove("epris-bundle-ui-ready")
      },
      hideSelect = sel => {
        sel.style.cssText = "position:absolute;left:-9999px;opacity:0;pointer-events:none;"
      },
      unhideSelects = () => {
        const sb = document.querySelector("#simple-bundles-io-options");
        sb && sb.querySelectorAll("select").forEach(sel => {
          sel.style.cssText = ""
        })
      };

    function injectCSS() {
      if (document.getElementById("epris-bundle-css")) return;
      const css = document.createElement("style");
      css.id = "epris-bundle-css", css.textContent = `
      #epris-bundle-ui { margin: 2px 0 18px; }
      .epris-slots-headline { font-size: 16px; color:#1c1c1c; margin: 0 0 10px; letter-spacing:.01em; text-align:center; }
      .epris-slots-headline strong { font-weight: 700; }
      .epris-slots-row { display:flex; gap:10px; justify-content:center; align-items:stretch; flex-wrap:nowrap; }
      .epris-slot { position:relative; flex:1 1 0; min-width:0; aspect-ratio:1/1.05; background:#fff; border:1px solid #e7e5df; border-radius:0; cursor:pointer; padding:0; overflow:hidden; transition:border-color .2s ease, box-shadow .2s ease, transform .15s ease; -webkit-tap-highlight-color:transparent; }
      .epris-slot:hover, .epris-slot:focus-visible { border-color:#1c1c1c; box-shadow:0 4px 14px rgba(0,0,0,.06); outline:none; }
      .epris-slot--empty .epris-slot__inner { width:100%; height:100%; display:flex; align-items:center; justify-content:center; color:#bdbab2; }
      .epris-slot__plus { font-size:28px; font-weight:300; line-height:1; }
      .epris-slot--filled { padding:0; border-color:transparent; box-shadow:none; }
      .epris-slot--filled:hover { border-color:transparent; box-shadow:none; }
      .epris-slot__img { width:100%; height:100%; object-fit:contain; padding:8px; display:block; }
      /* Remove-Button: hochspezifisch + !important damit theme's button-defaults nicht \xFCberschreiben.
         Gr\xF6\xDFeres X (18px) + st\xE4rkerer Kontrast (Schwarz statt Transparent-Schwarz) + Box-Shadow f\xFCr Sichtbarkeit auf hellen Bildern. */
      #epris-bundle-ui .epris-slot .epris-slot__remove {
        position:absolute !important; top:8px !important; right:8px !important;
        width:28px !important; height:28px !important; padding:0 !important; margin:0 !important;
        border:none !important; border-radius:50% !important;
        background:rgba(28,28,28,.92) !important; color:#fff !important;
        font-size:18px !important; font-weight:400 !important; line-height:1 !important;
        cursor:pointer !important; display:flex !important; align-items:center !important; justify-content:center !important;
        transition:background .2s ease, transform .15s ease !important;
        z-index:5 !important;
        box-shadow:0 2px 8px rgba(0,0,0,.3) !important;
        -webkit-tap-highlight-color:transparent !important;
        opacity:1 !important; visibility:visible !important;
      }
      #epris-bundle-ui .epris-slot .epris-slot__remove:hover { background:#000 !important; transform:scale(1.08) !important; }

      #epris-modal { position:fixed; inset:0; background:rgba(0,0,0,.55); backdrop-filter:blur(4px); -webkit-backdrop-filter:blur(4px); display:none; z-index:999999; padding:24px 10px; overflow-y:auto; -webkit-overflow-scrolling:touch; }
      #epris-modal-box { position:relative; max-width:640px; margin:0 auto; background:#fff; border-radius:14px; min-height:100px; }
      .epris-modal-header { padding:18px 20px 12px; border-bottom:1px solid #f0eee9; position:sticky; top:0; background:#fff; z-index:5; border-top-left-radius:14px; border-top-right-radius:14px; }
      .epris-modal-headline { font-size:15px; color:#1c1c1c; margin:0 32px 12px 0; text-align:center; }
      .epris-modal-headline strong { font-weight:700; }
      #epris-close { position:absolute; top:14px; right:16px; width:32px; height:32px; display:flex; align-items:center; justify-content:center; font-size:20px; line-height:1; cursor:pointer; border-radius:50%; transition:background .2s ease; z-index:6; }
      #epris-close:hover { background:#f4f4f4; }
      .epris-modal-slots { display:flex; gap:8px; justify-content:center; }
      .epris-modal-slot { position:relative; flex:1 1 0; min-width:0; aspect-ratio:1/1; background:#faf9f6; border:2px solid #e7e5df; cursor:pointer; padding:0; overflow:hidden; transition:border-color .2s ease, transform .12s ease; }
      .epris-modal-slot.active.empty { border-color:#1c1c1c; transform:scale(1.04); }
      .epris-modal-slot.filled { border-color:transparent; }
      .epris-modal-slot.active.filled { transform:scale(1.04); }
      .epris-modal-slot.empty { display:flex; align-items:center; justify-content:center; color:#bdbab2; font-size:22px; }
      .epris-modal-slot.filled img { width:100%; height:100%; object-fit:contain; padding:6px; display:block; }
      /* Modal-Slot-Remove — gleiche Spezifizit\xE4t-H\xE4rtung wie Page-Slot */
      #epris-modal .epris-modal-slot .epris-modal-slot__remove {
        position:absolute !important; top:4px !important; right:4px !important;
        width:22px !important; height:22px !important; padding:0 !important; margin:0 !important;
        border:none !important; border-radius:50% !important;
        background:rgba(28,28,28,.92) !important; color:#fff !important;
        font-size:13px !important; font-weight:400 !important; line-height:1 !important;
        cursor:pointer !important; display:flex !important; align-items:center !important; justify-content:center !important;
        transition:background .2s ease, transform .15s ease !important;
        z-index:5 !important;
        box-shadow:0 2px 6px rgba(0,0,0,.25) !important;
        opacity:1 !important; visibility:visible !important;
      }
      #epris-modal .epris-modal-slot .epris-modal-slot__remove:hover { background:#000 !important; transform:scale(1.1) !important; }

      .epris-modal-controls { padding:12px 18px 10px; border-bottom:1px solid #f0eee9; }
      .epris-filter-toggle { display:flex; align-items:center; justify-content:space-between; width:100%; padding:10px 0; background:transparent; border:none; cursor:pointer; font-size:12px; letter-spacing:.08em; color:#1c1c1c; font-weight:600; text-transform:uppercase; -webkit-tap-highlight-color:transparent; }
      .epris-filter-toggle:hover { color:#000; }
      .epris-filter-toggle__chevron { display:inline-flex; align-items:center; justify-content:center; width:32px; height:32px; border:1.5px solid #1c1c1c; border-radius:50%; color:#1c1c1c; transition:transform .35s cubic-bezier(.4,0,.2,1), background .2s ease, color .2s ease; flex-shrink:0; }
      .epris-filter-toggle__chevron svg { width:14px; height:14px; display:block; }
      .epris-filter-toggle:hover .epris-filter-toggle__chevron { background:#1c1c1c; color:#fff; }
      .epris-filter-toggle.is-open .epris-filter-toggle__chevron { transform:rotate(180deg); background:#1c1c1c; color:#fff; }
      .epris-filter-collapse { max-height:0; opacity:0; overflow:hidden; transition:max-height .42s cubic-bezier(.4,0,.2,1), opacity .32s ease; }
      .epris-filter-collapse.is-open { max-height:280px; opacity:1; }
      .epris-filter-section { margin-bottom:14px; }
      .epris-filter-section:last-child { margin-bottom:8px; }
      .epris-filter-cards { display:flex; gap:14px; overflow-x:auto; padding:2px 0 4px; -webkit-overflow-scrolling:touch; scrollbar-width:none; flex-wrap:nowrap; }
      .epris-filter-cards::-webkit-scrollbar { display:none; }
      .epris-filter-cards[data-filter="geschlecht"] { justify-content:center; }
      .epris-filter-cards[data-filter="dufttyp"] { justify-content:flex-start; padding-left:2px; padding-right:8px; }
      .epris-filter-card { flex:0 0 auto; min-width:64px; padding:4px 2px; border:none; background:transparent; cursor:pointer; display:flex; flex-direction:column; align-items:center; gap:6px; transition:transform .12s ease, opacity .15s ease; -webkit-tap-highlight-color:transparent; opacity:.65; }
      .epris-filter-card:hover { opacity:1; }
      .epris-filter-card.active { opacity:1; }
      .epris-filter-card__img { width:52px; height:52px; background:#faf9f6; display:flex; align-items:center; justify-content:center; font-size:24px; line-height:1; overflow:hidden; transition:outline .15s ease; outline:2px solid transparent; outline-offset:2px; }
      .epris-filter-card__img img { width:100%; height:100%; object-fit:cover; display:block; }
      .epris-filter-card.active .epris-filter-card__img { outline-color:#1c1c1c; }
      .epris-filter-card__label { font-size:11px; color:#1c1c1c; letter-spacing:.02em; font-weight:500; text-align:center; transition:font-weight .15s ease; }
      .epris-filter-card.active .epris-filter-card__label { font-weight:700; }

      .epris-search-wrap { position:relative; }
      #epris-search { width:100%; padding:10px 38px 10px 12px; background:#fff; border:1px solid #ddd; border-radius:8px; font-size:14px; box-sizing:border-box; margin-top:4px; }
      #epris-search:focus { outline:none; border-color:#1c1c1c; }
      .epris-search-info { position:absolute; right:8px; top:calc(50% + 2px); transform:translateY(-50%); width:22px; height:22px; padding:0; border:1px solid #c4c4c4; border-radius:50%; background:#fff; color:#888; font-size:11px; font-weight:600; line-height:1; cursor:pointer; display:flex; align-items:center; justify-content:center; transition:border-color .15s ease, color .15s ease; }
      .epris-search-info:hover, .epris-search-info.active { border-color:#1c1c1c; color:#1c1c1c; }
      .epris-search-tooltip { position:absolute; top:calc(100% + 8px); right:0; max-width:260px; background:#1c1c1c; color:#fff; padding:10px 12px; border-radius:8px; font-size:12px; line-height:1.4; box-shadow:0 6px 16px rgba(0,0,0,.18); opacity:0; transform:translateY(-4px); pointer-events:none; transition:opacity .2s ease, transform .2s ease; z-index:10; }
      .epris-search-tooltip::before { content:''; position:absolute; top:-5px; right:14px; width:10px; height:10px; background:#1c1c1c; transform:rotate(45deg); }
      .epris-search-tooltip.show { opacity:1; transform:translateY(0); pointer-events:auto; }

      #epris-results { padding:14px 16px 18px; }
      .epris-grid { display:grid; grid-template-columns:repeat(auto-fill, minmax(140px, 1fr)); gap:18px 14px; }
      .epris-card { display:flex; flex-direction:column; align-items:center; text-align:center; padding:6px 4px 10px; border:none; background:transparent; cursor:pointer; transition:transform .12s ease, opacity .15s ease; -webkit-tap-highlight-color:transparent; position:relative; }
      .epris-card:hover { opacity:.85; }
      .epris-card:active { transform:scale(.98); }
      .epris-card__img-wrap { position:relative; width:100%; aspect-ratio:1/1; margin-bottom:8px; }
      .epris-card__img { width:100%; height:100%; object-fit:contain; display:block; }
      .epris-card__pill { position:absolute; bottom:6px; left:6px; z-index:2; padding:2px 10px; background:rgba(0,0,0,0.45); color:#f4f4f4; font-size:10px; letter-spacing:0.4px; border-radius:12px; backdrop-filter:blur(3px); -webkit-backdrop-filter:blur(3px); box-shadow:0 2px 5px rgba(0,0,0,.15); white-space:nowrap; }
      .epris-card__title { font-size:10px; color:#1c1c1c; font-weight:600; line-height:1.25; white-space:nowrap; overflow:hidden; text-overflow:ellipsis; max-width:100%; letter-spacing:.02em; }
      .epris-card__vendor { font-size:10px; color:#888; margin-top:5px; }
      .epris-card__rating { display:flex; align-items:center; gap:4px; font-size:10px; color:#1c1c1c; margin-top:6px; }
      .epris-card__stars { display:inline-flex; gap:1px; font-size:11px; line-height:1; letter-spacing:.5px; }
      .epris-card__stars .s-full { color:#f5b301; }
      .epris-card__stars .s-empty { color:#ddd; }
      .epris-card__stars .s-half { position:relative; color:#ddd; display:inline-block; }
      .epris-card__stars .s-half::after { content:'★'; position:absolute; left:0; top:0; width:50%; color:#f5b301; overflow:hidden; }
      .epris-empty { padding:18px; color:#888; text-align:center; font-size:13px; }
      .epris-result-count { padding:0 0 12px; font-size:11px; color:#888; letter-spacing:.04em; text-align:left; }
      mark.epris-hl { background:#ffe58f; padding:0 1px; border-radius:2px; }

      /* Theme's altes Loading-Screen permanent unterdr\xFCcken — Premium-Loader \xFCbernimmt komplett */
      #loading-screen { display:none !important; }

      /* BUNDLE LOADER (Auto-ATC \xDCbergang) */
      #epris-bundle-loader { position:fixed; inset:0; background:rgba(255,255,255,.97); backdrop-filter:blur(8px); -webkit-backdrop-filter:blur(8px); z-index:9999999; display:flex; align-items:center; justify-content:center; flex-direction:column; opacity:0; pointer-events:none; transition:opacity .18s ease; }
      #epris-bundle-loader.show { opacity:1; pointer-events:auto; }
      #epris-bundle-loader.fadeout { opacity:0; pointer-events:none; }
      .ebl__stage { position:relative; width:160px; height:160px; display:flex; align-items:center; justify-content:center; }
      .ebl__ring { position:absolute; left:50%; top:50%; width:80px; height:80px; margin:-40px 0 0 -40px; border:1.5px solid #1c1c1c; border-radius:50%; opacity:0; animation:ebl-pulse 2s cubic-bezier(.4,0,.2,1) infinite; }
      .ebl__ring:nth-child(2) { animation-delay:.5s; }
      .ebl__ring:nth-child(3) { animation-delay:1s; }
      .ebl__logo { position:relative; z-index:2; width:90px; height:auto; animation:ebl-breath 2.4s ease-in-out infinite; }
      .ebl__text { margin-top:36px; font-size:11px; letter-spacing:.18em; color:#888; text-transform:uppercase; font-weight:500; animation:ebl-text 2.4s ease-in-out infinite alternate; }
      .ebl__sub { margin-top:6px; font-size:10px; letter-spacing:.08em; color:#bbb; text-transform:uppercase; }
      .ebl__progress { position:absolute; bottom:48px; left:50%; transform:translateX(-50%); width:160px; height:1px; background:rgba(0,0,0,.08); overflow:hidden; }
      .ebl__progress::after { content:''; position:absolute; left:-30%; top:0; width:30%; height:100%; background:#1c1c1c; animation:ebl-bar 1.4s cubic-bezier(.5,0,.5,1) infinite; }
      @keyframes ebl-pulse { 0% { transform:scale(.5); opacity:1; border-width:2px; } 100% { transform:scale(2.4); opacity:0; border-width:.5px; } }
      @keyframes ebl-breath { 0%, 100% { transform:scale(1); opacity:1; } 50% { transform:scale(.93); opacity:.85; } }
      @keyframes ebl-text { from { opacity:.4; } to { opacity:1; } }
      @keyframes ebl-bar { 0% { transform:translateX(0); } 100% { transform:translateX(540%); } }
    `, document.head.appendChild(css)
    }

    function ensureContainer() {
      let container = document.querySelector("#epris-bundle-ui");
      if (container) return container.innerHTML = "", container;
      container = document.createElement("div"), container.id = "epris-bundle-ui";
      const sb = document.querySelector("#simple-bundles-io-options");
      return sb && sb.insertAdjacentElement("beforebegin", container), container
    }

    function createSlotsRow() {
      appSelects = getSelects(), bundleSize = appSelects.length;
      const container = ensureContainer(),
        headlineTpl = window.EPRIS_TRANS?.bundleHeadline || `W\xE4hle frei deine <strong>${bundleSize}x D\xFCfte</strong>`;
      container.innerHTML = `
      <div class="epris-slots-headline">${headlineTpl.replace("{n}",bundleSize)}</div>
      <div class="epris-slots-row" data-bundle-size="${bundleSize}"></div>
    `;
      const row = container.querySelector(".epris-slots-row");
      slots = [], slotsState = new Array(bundleSize).fill(null);
      for (let i = 0; i < bundleSize; i++) {
        const slot = document.createElement("button");
        slot.type = "button", slot.className = "epris-slot epris-slot--empty", slot.dataset.index = i, slot.innerHTML = '<div class="epris-slot__inner"><span class="epris-slot__plus">+</span></div>', slot.addEventListener("click", () => onSlotClick(i)), row.appendChild(slot), slots.push(slot)
      }
    }

    function onSlotClick(index) {
      activeSlotIndex = index, openModal()
    }

    function fillSlot(index, item) {
      slotsState[index] = item;
      const slot = slots[index];
      slot.classList.remove("epris-slot--empty"), slot.classList.add("epris-slot--filled"), slot.innerHTML = `
      <img class="epris-slot__img" src="${item.image||""}" alt="${(item.clean||"").replace(/"/g,"&quot;")}" loading="lazy">
      <button class="epris-slot__remove" type="button" aria-label="${__ept("bundleSlotRemove","Entfernen")}">\xD7</button>
    `, slot.querySelector(".epris-slot__remove").addEventListener("click", e => {
        e.stopPropagation(), clearSlot(index)
      });
      const sel = appSelects[index];
      sel && (sel.value = item.value, sel.dispatchEvent(new Event("change", {
        bubbles: !0
      }))), updateModalSlots()
    }

    function clearSlot(index) {
      slotsState[index] = null;
      const slot = slots[index];
      slot.classList.remove("epris-slot--filled"), slot.classList.add("epris-slot--empty"), slot.innerHTML = '<div class="epris-slot__inner"><span class="epris-slot__plus">+</span></div>';
      const sel = appSelects[index];
      sel && (sel.value = "", sel.dispatchEvent(new Event("change", {
        bubbles: !0
      }))), (activeSlotIndex >= bundleSize || activeSlotIndex < 0) && (activeSlotIndex = index), updateModalSlots()
    }

    function getNextEmptySlot(fromIndex) {
      const start = typeof fromIndex == "number" ? fromIndex : 0;
      for (let off = 0; off < bundleSize; off++) {
        const i = (start + off) % bundleSize;
        if (!slotsState[i]) return i
      }
      return -1
    }

    function ensureModal() {
      if (modal) return;
      modal = document.createElement("div"), modal.id = "epris-modal";
      const headlineTpl = window.EPRIS_TRANS?.bundleHeadline || `W\xE4hle frei deine <strong>${bundleSize}x D\xFCfte</strong>`,
        searchPh = window.EPRIS_TRANS?.searchScent || "Nach Produktname oder Hersteller suchen";
      modal.innerHTML = `
      <div id="epris-modal-box">
        <div class="epris-modal-header">
          <div id="epris-close" role="button" aria-label="${__ept("bundleModalClose","Schlie\xDFen")}">✕</div>
          <div class="epris-modal-headline">${headlineTpl.replace("{n}",bundleSize)}</div>
          <div class="epris-modal-slots"></div>
        </div>
        <div class="epris-modal-controls">
          <button type="button" class="epris-filter-toggle" id="epris-filter-toggle" aria-expanded="false">
            <span>${__ept("bundleFilterToggle","Nach Geschlecht oder Duftnote filtern")}</span>
            <span class="epris-filter-toggle__chevron" aria-hidden="true"><svg viewBox="0 0 16 16" fill="none"><path d="M4 6l4 4 4-4" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg></span>
          </button>
          <div class="epris-filter-collapse" id="epris-filter-collapse">
            <div class="epris-filter-section">
              <div class="epris-filter-cards" data-filter="geschlecht"></div>
            </div>
            <div class="epris-filter-section">
              <div class="epris-filter-cards" data-filter="dufttyp"></div>
            </div>
          </div>
          <div class="epris-search-wrap">
            <input id="epris-search" type="text" placeholder="${searchPh}" autocomplete="off">
            <button type="button" class="epris-search-info" id="epris-search-info" aria-label="${__ept("bundleSearchHint","Such-Hinweis")}">i</button>
            <div class="epris-search-tooltip" id="epris-search-tooltip">${__ept("bundleSearchTooltip","Suche nach Duftnamen, Duftnoten, deinem Lieblingsduft oder N\xB0-Codes — alle Felder werden gleichzeitig durchsucht.")}</div>
          </div>
        </div>
        <div id="epris-results"></div>
      </div>
    `, document.body.appendChild(modal), search = modal.querySelector("#epris-search"), results = modal.querySelector("#epris-results"), modalSlotsEl = modal.querySelector(".epris-modal-slots"), filterBar = modal.querySelector(".epris-modal-controls"), modal.querySelector("#epris-close").addEventListener("click", closeModal), modal.addEventListener("click", e => {
        e.target.id === "epris-modal" && closeModal()
      });
      let inputTimer;
      search.addEventListener("input", e => {
        clearTimeout(inputTimer), inputTimer = setTimeout(() => renderResults(e.target.value), 80)
      }), results.addEventListener("click", handleRowClick);
      const filterToggle = modal.querySelector("#epris-filter-toggle"),
        filterCollapse = modal.querySelector("#epris-filter-collapse");
      filterToggle && filterCollapse && filterToggle.addEventListener("click", () => {
        const isOpen = filterToggle.classList.toggle("is-open");
        filterCollapse.classList.toggle("is-open", isOpen), filterToggle.setAttribute("aria-expanded", isOpen ? "true" : "false")
      });
      const infoBtn = modal.querySelector("#epris-search-info"),
        infoTip = modal.querySelector("#epris-search-tooltip");
      infoBtn.addEventListener("click", e => {
        e.stopPropagation();
        const willShow = !infoTip.classList.contains("show");
        infoTip.classList.toggle("show", willShow), infoBtn.classList.toggle("active", willShow)
      }), document.addEventListener("click", e => {
        !e.target.closest("#epris-search-info") && !e.target.closest("#epris-search-tooltip") && (infoTip.classList.remove("show"), infoBtn.classList.remove("active"))
      }), buildFilters()
    }

    function buildFilters() {
      const geschlechtBar = filterBar.querySelector('[data-filter="geschlecht"]'),
        dufttypBar = filterBar.querySelector('[data-filter="dufttyp"]');
      geschlechtBar.innerHTML = GESCHLECHT_FILTERS.map(g => `<button type="button" class="epris-filter-card" data-filter-type="geschlecht" data-value="${g.key}">
         <span class="epris-filter-card__img"><img src="${g.image}" alt="${g.label}" loading="lazy"></span>
         <span class="epris-filter-card__label">${g.label}</span>
       </button>`).join(""), dufttypBar.innerHTML = DUFTRICHTUNG_FILTERS.map(d => `<button type="button" class="epris-filter-card" data-filter-type="dufttyp" data-value="${d.key}">
         <span class="epris-filter-card__img"><img src="${d.image}" alt="${d.label}" loading="lazy"></span>
         <span class="epris-filter-card__label">${d.label}</span>
       </button>`).join(""), filterBar.addEventListener("click", e => {
        const card = e.target.closest(".epris-filter-card");
        if (!card) return;
        const type = card.dataset.filterType,
          val = card.dataset.value;
        if (type === "dufttyp") {
          const idx = activeFilters.dufttyp.indexOf(val);
          idx > -1 ? (activeFilters.dufttyp.splice(idx, 1), card.classList.remove("active")) : (activeFilters.dufttyp.push(val), card.classList.add("active"))
        } else activeFilters[type] === val ? (activeFilters[type] = null, card.classList.remove("active")) : (activeFilters[type] = val, filterBar.querySelectorAll(`.epris-filter-card[data-filter-type="${type}"]`).forEach(c => c.classList.remove("active")), card.classList.add("active"));
        renderResults(search.value)
      })
    }

    function updateModalSlots() {
      if (modalSlotsEl) {
        modalSlotsEl.innerHTML = "";
        for (let i = 0; i < bundleSize; i++) {
          const s = document.createElement("button");
          s.type = "button", s.className = "epris-modal-slot " + (slotsState[i] ? "filled" : "empty") + (i === activeSlotIndex ? " active" : ""), s.dataset.index = i, slotsState[i] ? s.innerHTML = `<img src="${slotsState[i].image||""}" alt="" loading="lazy"><button type="button" class="epris-modal-slot__remove" aria-label="${__ept("bundleSlotRemove","Entfernen")}">\xD7</button>` : s.innerHTML = "<span>+</span>", s.addEventListener("click", e => {
            if (e.target.closest(".epris-modal-slot__remove")) {
              e.stopPropagation(), clearSlot(i);
              return
            }
            activeSlotIndex = i, updateModalSlots()
          }), modalSlotsEl.appendChild(s)
        }
      }
    }

    function openModal() {
      if (ensureModal(), activeSlotIndex < 0 || activeSlotIndex >= bundleSize) {
        const next = getNextEmptySlot(0);
        activeSlotIndex = next === -1 ? 0 : next
      }
      modal.style.display = "block", search.value = "", updateModalSlots(), renderResults(""), requestAnimationFrame(() => search.focus())
    }

    function closeModal() {
      modal && (modal.style.display = "none")
    }
    async function buildOptionModel() {
      const selects = getSelects();
      if (!selects.length) return;
      const meta = await loadMeta(),
        metaMap = new Map;
      meta.forEach(p => {
        const code = extractCode(p.title);
        code && metaMap.set(code, p)
      });
      const seenCodes = new Set;
      ALL_OPTIONS = [...selects[0].options].filter(o => {
        if (!o.value || o.disabled) return !1;
        const code = extractCode(o.textContent || "");
        /* nur-mobil markierte Duefte auf Desktop gar nicht erst aufnehmen */
        if (code && EPRIS_OVERRIDES[code] && EPRIS_OVERRIDES[code].mobileOnly && !isMobileView()) return !1;
        return code && seenCodes.has(code) ? !1 : (code && seenCodes.add(code), !0)
      }).map(o => {
        const txt = o.textContent.trim();
        let clean = txt.replace("(Bestseller)", "");
        window.EPRIS_TRANS?.inspiredBy && (clean = clean.replace(/Inspiriert\s+von/gi, window.EPRIS_TRANS.inspiredBy)), clean = clean.trim();
        const code = extractCode(txt),
          m = metaMap.get(code) || {},
          ov = EPRIS_OVERRIDES[code] || {},
          tagsStr = (m.tags || "").toLowerCase(),
          dufttypArr = Array.isArray(m.dufttyp) ? m.dufttyp.filter(Boolean).map(s => String(s).toLowerCase().trim()) : [],
          geschlecht = String(m.geschlecht || "").toLowerCase().trim(),
          productTitle = ov.title || m.title || clean;
        return {
          text: txt,
          clean,
          title: productTitle,
          value: o.value,
          search: normalize(`${productTitle} ${clean} ${m.vendor||""} ${m.duftmarke||""} ${dufttypArr.join(" ")} ${tagsStr}`),
          vendor: ov.vendor || m.vendor || "",
          marke: m.duftmarke || "",
          image: ov.image || m.image || "",
          handle: m.handle || "",
          geschlecht,
          dufttyp: dufttypArr,
          duftfamilie: String(m.duftfamilie || "").toLowerCase(),
          rating: parseFloat(m.rating) || 0,
          rating_count: parseInt(m.rating_count) || 0,
          isBest: txt.includes("(Bestseller)")
        }
      }), ALL_OPTIONS.sort((a, b) => b.isBest - a.isBest)
    }

    function matchesDuftrichtung(item, filterKey) {
      const filter = DUFTRICHTUNG_FILTERS.find(f => f.key === filterKey);
      if (!filter) return !0;
      const haystack = (item.dufttyp.join(" ") + " " + item.duftfamilie).toLowerCase();
      return filter.match.some(pattern => haystack.includes(pattern))
    }

    function renderResults(q) {
      const queryNorm = normalize(q);
      let list = queryNorm ? ALL_OPTIONS.filter(o => o.search.includes(queryNorm)) : ALL_OPTIONS;
      if (activeFilters.geschlecht) {
        const f = activeFilters.geschlecht;
        f === "unisex" ? list = list.filter(o => o.geschlecht === "unisex") : list = list.filter(o => o.geschlecht === f || o.geschlecht === "unisex")
      }
      activeFilters.dufttyp.length > 0 && (list = list.filter(o => activeFilters.dufttyp.every(filter => matchesDuftrichtung(o, filter))));
      const total = ALL_OPTIONS.length,
        visible = list.length,
        countText = visible === total ? __ept("bundleScentsAvailable", "{n} D\xFCfte verf\xFCgbar", {
          n: visible
        }) : __ept("bundleScentsOf", "{visible} von {total} D\xFCften", {
          visible,
          total
        });
      if (!list.length) {
        const noRes = window.EPRIS_TRANS?.noResults || "Keine Treffer";
        results.innerHTML = `<div class="epris-result-count">${__ept("bundleScentsOf","{visible} von {total} D\xFCften",{visible:0,total})}</div><div class="epris-empty">${noRes}</div>`;
        return
      }
      const highlightRegex = queryNorm ? new RegExp(`(${queryNorm.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")})`, "gi") : null,
        highlight = txt => highlightRegex ? txt.replace(highlightRegex, '<mark class="epris-hl">$1</mark>') : txt,
        grid = document.createElement("div");
      grid.className = "epris-grid", list.forEach(item => {
        const card = document.createElement("button");
        card.type = "button", card.className = "epris-card", card.dataset.value = item.value;
        let starsHtml = "";
        if (item.rating > 0) {
          const r = Math.max(0, Math.min(5, item.rating));
          for (let i = 1; i <= 5; i++) r >= i ? starsHtml += '<span class="s-full">★</span>' : r >= i - .5 ? starsHtml += '<span class="s-half">★</span>' : starsHtml += '<span class="s-empty">★</span>'
        }
        const ratingHtml = item.rating > 0 ? `<div class="epris-card__rating"><span class="epris-card__stars">${starsHtml}</span> ${item.rating.toFixed(1)} ${item.rating_count?`(${item.rating_count})`:""}</div>` : "",
          pillHtml = item.isBest ? '<span class="epris-card__pill">Bestseller</span>' : "",
          vendorHtml = item.vendor ? `<div class="epris-card__vendor">${item.vendor}</div>` : "",
          imgHtml = item.image ? `<img class="epris-card__img" src="${item.image}" alt="" loading="lazy">` : '<div class="epris-card__img" style="background:#f4f4f4;"></div>';
        card.innerHTML = `
        <div class="epris-card__img-wrap">${imgHtml}${pillHtml}</div>
        <div class="epris-card__title">${highlight(item.title)}</div>
        ${vendorHtml}
        ${ratingHtml}
      `, grid.appendChild(card)
      }), results.innerHTML = "";
      const countEl = document.createElement("div");
      countEl.className = "epris-result-count", countEl.textContent = countText, results.appendChild(countEl), results.appendChild(grid), results.scrollTop = 0
    }
    let _bundleLoaderHideTimer = null;

    function ensureBundleLoader() {
      if (document.getElementById("epris-bundle-loader")) return;
      const el = document.createElement("div");
      el.id = "epris-bundle-loader", el.innerHTML = `
      <div class="ebl__stage">
        <span class="ebl__ring"></span>
        <span class="ebl__ring"></span>
        <span class="ebl__ring"></span>
        <img class="ebl__logo" src="https://cdn.shopify.com/s/files/1/0782/7400/3287/files/Logo.svg?v=1729751366" alt="">
      </div>
      <div class="ebl__text">${window.EPRIS_TRANS?.loaderBundleTitle||"Dein Duft-Bundle wird zusammengestellt"}</div>
      <div class="ebl__sub">${window.EPRIS_TRANS?.loaderBundleSub||"Einen Moment"}</div>
      <div class="ebl__progress"></div>
    `, document.body.appendChild(el)
    }

    function showBundleLoader() {
      ensureBundleLoader();
      const el = document.getElementById("epris-bundle-loader");
      if (!el || el.classList.contains("show")) return;
      const isBundle = !!document.querySelector("#epris-bundle-ui"),
        txt = el.querySelector(".ebl__text"),
        sub = el.querySelector(".ebl__sub");
      txt && (txt.textContent = isBundle ? window.EPRIS_TRANS?.loaderBundleTitle || "Dein Duft-Bundle wird zusammengestellt" : window.EPRIS_TRANS?.loaderSingleTitle || "Dein Duft wird hinzugef\xFCgt"), sub && (sub.textContent = isBundle ? window.EPRIS_TRANS?.loaderBundleSub || "Einen Moment" : window.EPRIS_TRANS?.loaderSingleSub || "Einen Augenblick"), el.classList.add("show"), el.classList.remove("fadeout"), document.body.style.overflow = "hidden";

      function hide() {
        el.classList.add("fadeout"), el.classList.remove("show"), setTimeout(() => {
          document.body.style.overflow = ""
        }, 200)
      }
      let triggered = !1;
      const onceHide = () => {
          triggered || (triggered = !0, setTimeout(hide, 80))
        },
        drawer = document.querySelector("cart-drawer");
      let mo = null;
      drawer && (mo = new MutationObserver(() => {
        drawer.hasAttribute("open") && (mo && mo.disconnect(), onceHide())
      }), mo.observe(drawer, {
        attributes: !0,
        attributeFilter: ["open"]
      }), drawer.hasAttribute("open") && onceHide());
      const evtHandler = () => {
        mo && mo.disconnect(), onceHide()
      };
      document.body.addEventListener("cart:product-added", evtHandler, {
        once: !0
      }), document.documentElement.addEventListener("cart:change", evtHandler, {
        once: !0
      }), clearTimeout(_bundleLoaderHideTimer), _bundleLoaderHideTimer = setTimeout(() => {
        mo && mo.disconnect(), onceHide()
      }, 7e3)
    }

    function triggerAutoATC() {
      const candidates = ['buy-buttons button[type="submit"]', 'buy-buttons button[name="add"]', 'form[action*="/cart/add"] button[type="submit"]', 'button[name="add"]', 'button[type="submit"][form*="product-form"]'];
      for (const sel of candidates) {
        const btn = document.querySelector(sel);
        if (btn && !btn.disabled) return btn.click(), !0
      }
      return !1
    }

    function handleRowClick(evt) {
      const card = evt.target.closest(".epris-card");
      if (!card) return;
      const item = ALL_OPTIONS.find(o => o.value === card.dataset.value);
      if (!item) return;
      const target = activeSlotIndex >= 0 && activeSlotIndex < bundleSize ? activeSlotIndex : 0;
      fillSlot(target, item);
      const next = getNextEmptySlot(target + 1);
      next === -1 ? setTimeout(() => {
        closeModal(), showBundleLoader(), setTimeout(triggerAutoATC, 200)
      }, 280) : (activeSlotIndex = next, updateModalSlots())
    }

    function isUiFullyRendered() {
      const container = document.querySelector("#epris-bundle-ui");
      if (!container) return !1;
      const row = container.querySelector(".epris-slots-row");
      if (!row) return !1;
      const renderedSlots = row.querySelectorAll(".epris-slot");
      return bundleSize > 0 && renderedSlots.length !== bundleSize ? !1 : renderedSlots.length > 0
    }

    function syncSelectsFromState() {
      try {
        const sels = getSelects();
        let stable = !0;
        for (let i = 0; i < bundleSize; i++) {
          const item = slotsState[i];
          if (!item) continue;
          const sel = sels[i];
          if (!sel) {
            stable = !1;
            continue
          }
          if (sel.value !== item.value) {
            [...sel.options].some(o => o.value === item.value) && (sel.value = item.value, sel.dispatchEvent(new Event("change", {
              bubbles: !0
            })));
            stable = !1
          }
        }
        return stable
      } catch (e) {
        return !0
      }
    }

    function applyUrlPreselect() {
      if (window.__eprisPreselectDone) return;
      window.__eprisPreselectDone = !0;
      try {
        const q = new URLSearchParams(location.search),
          codes = [];
        for (let i = 1; i <= 9; i++) {
          const v = (q.get("d" + i) || "").replace(/[^0-9]/g, "");
          v && codes.push(parseInt(v, 10))
        }
        if (!codes.length) return;
        let cancelled = !1;
        const cancel = e => {
          e.target && e.target.closest && e.target.closest("#epris-bundle-ui,#epris-modal") && (cancelled = !0, document.removeEventListener("click", cancel, !0))
        };
        document.addEventListener("click", cancel, !0);
        let n = 0,
          calm = 0;
        const t = setInterval(() => {
          if (n++, cancelled || n > 60) {
            clearInterval(t);
            return
          }
          if (!initialized) return;
          let placed = 0;
          const wanted = codes.slice(0, bundleSize);
          wanted.forEach((want, i) => {
            if (slotsState[i]) {
              placed++;
              return
            }
            const item = ALL_OPTIONS.find(o => parseInt(extractCode(o.text || o.clean || ""), 10) === want);
            item ? (fillSlot(i, item), placed++) : placed++
          });
          const stable = syncSelectsFromState();
          placed >= wanted.length && stable ? calm++ : calm = 0;
          calm >= 5 && clearInterval(t)
        }, 500)
      } catch (e) {
        console.warn("[EPRIS Bundle] preselect:", e)
      }
    }
    async function init() {
      if (!(initialized || initRunning)) {
        initRunning = !0;
        try {
          const selects = getSelects();
          if (!selects.length || selects[0].options.length === 0) return;
          if (await buildOptionModel(), createSlotsRow(), ensureModal(), !isUiFullyRendered()) {
            markBundleUiFailed(), unhideSelects();
            return
          }
          selects.forEach(sel => hideSelect(sel)), markBundleUiReady(), initialized = !0, applyUrlPreselect()
        } catch (err) {
          console.error("[EPRIS Bundle] init failed, falling back to Simple Bundles UI:", err), markBundleUiFailed(), unhideSelects(), initialized = !1
        } finally {
          initRunning = !1
        }
      }
    }

    function attachManualATCListener() {
      window.__eprisBundleATCBound || (window.__eprisBundleATCBound = !0, document.addEventListener("click", e => {
        const btn = e.target.closest('buy-buttons button[type="submit"], button[name="add"], form[action*="/cart/add"] button[type="submit"]');
        !btn || document.querySelector("#epris-bundle-ui") && (!slotsState.length || slotsState.some(s => !s)) || btn.name === "checkout" || btn.matches('[name="checkout"]') || showBundleLoader()
      }, !0), document.body.addEventListener("cart:product-added", () => {
        const loader = document.getElementById("epris-bundle-loader");
        (!loader || !loader.classList.contains("show")) && showBundleLoader()
      }))
    }
    injectCSS(), attachManualATCListener();
    let observerActive = !1;

    function setupFullObserver() {
      const sbRoot = document.querySelector("[data-simple-bundles-options]");
      sbRoot && !observerActive && (observerActive = !0, new MutationObserver(() => {
        clearTimeout(initTimer), initTimer = setTimeout(() => init(), 100)
      }).observe(sbRoot, {
        childList: !0,
        subtree: !0
      }), clearTimeout(initTimer), initTimer = setTimeout(() => init(), 100))
    }
    new MutationObserver(() => setupFullObserver()).observe(document.body, {
      childList: !0,
      subtree: !0
    }), setupFullObserver(), window.addEventListener("load", () => {
      setupFullObserver(), clearTimeout(initTimer), initTimer = setTimeout(() => init(), 500)
    });
    const isOnBundlePage = () => !!document.querySelector("#simple-bundles-io-options, [data-simple-bundles-options]"),
      watchdogInterval = setInterval(() => {
        isOnBundlePage() && (initialized && isUiFullyRendered() || (initialized && !isUiFullyRendered() && (initialized = !1, markBundleUiFailed()), initRunning || (setupFullObserver(), init())))
      }, 700);
    window.addEventListener("beforeunload", () => clearInterval(watchdogInterval));

    function setupViewportTrigger() {
      const target = document.querySelector("#simple-bundles-io-options, [data-simple-bundles-options]");
      if (!target || target._eprisIoBound) return;
      target._eprisIoBound = !0, new IntersectionObserver(entries => {
        entries.forEach(entry => {
          entry.isIntersecting && !initialized && (setupFullObserver(), clearTimeout(initTimer), initTimer = setTimeout(() => init(), 50))
        })
      }, {
        rootMargin: "300px 0px"
      }).observe(target)
    }
    setupViewportTrigger(), setTimeout(setupViewportTrigger, 800), setTimeout(setupViewportTrigger, 2500), document.addEventListener("click", e => {
      initialized || e.target.closest("#simple-bundles-io-options, [data-simple-bundles-options], #epris-bundle-ui") && (setupFullObserver(), clearTimeout(initTimer), initTimer = setTimeout(() => init(), 30))
    }, !0)
  })()
} catch (e) {
  console.error("[EPRIS Bundle] fatal error in IIFE:", e)
}